"use client";

import {
  createContext,
  Dispatch,
  JSX,
  ReactNode,
  SetStateAction,
  useState
} from "react";

interface LightBoxState {
  current: number;
  setCurrent: Dispatch<SetStateAction<number>>;
  setVisible: Dispatch<SetStateAction<boolean>>;
  visible: boolean;
}

export const LightBoxContext = createContext<LightBoxState>({
  current: 0,
  setCurrent: () => {},
  setVisible: () => {},
  visible: false
});

interface LightBoxProps {
  children?: ReactNode;
}

export function LightBoxContextProvider({
  children
}: LightBoxProps): JSX.Element {
  const [visible, setVisible] = useState<LightBoxState["visible"]>(false);
  const [current, setCurrent] = useState<LightBoxState["current"]>(0);

  return (
    <LightBoxContext.Provider
      value={{ current, setCurrent, setVisible, visible }}
    >
      {children}
    </LightBoxContext.Provider>
  );
}
